import { useEffect, useState } from 'react'
import ReorderModal from '../Common/Modal/ReorderModal';
import { useDispatch, useSelector } from 'react-redux';
import { getFavouriteList, removeFavourite, setFavouriteUpdated } from '../../app/favourite/favourite.slice';
import Pagination from '.././Common/Pagination';
import DefaultPagination from "../../config/Pagination";
import { toast } from 'react-toastify';
import { image_url, MENU_IMAGE_PATH } from '../../Utils/baseUrl';

const UserFavourite = ({ user }) => {
    const [showModal, setShowModal] = useState(false);
    const [reorderData, setReorderData] = useState({});
    const dispatch = useDispatch();
    // Use state to manage favourite user data
    const [userFavouriteData, setUserFavouriteData] = useState({
        search: '',
        pageSize: DefaultPagination.PAGE_SIZE,
        pageNumber: DefaultPagination.PAGE_NUMBER,
    });

    const userId = user?.user?.data?.idUser;

    useEffect(() => {
        dispatch(getFavouriteList({ data: userFavouriteData, userId }));
    }, [userFavouriteData.pageNumber, userFavouriteData.pageSize, dispatch])

    const { favourites } = useSelector((state) => state.favourite);

    const paginationWithPage = (pageNumber) => {
        setUserFavouriteData((prevUserData) => ({ ...prevUserData, pageNumber: pageNumber }));
        dispatch(getFavouriteList({ data: userFavouriteData, userId }));
    };

    const toggleFavorite = async (orderId) => {
        const data = {
            orderId: orderId,
            userId: userId,
            deleteflag: 1
        }
        // dispatch function to remove the favourite
        const response = await dispatch(removeFavourite(data));
        if (response.payload?.status) {
            // Show success message
            toast.success(response?.payload?.message);
            dispatch(setFavouriteUpdated(true)); // trigger update in other components
        }

        // Update the local state to reflect the change
        dispatch(getFavouriteList({ data: userFavouriteData, userId }));
    };

    const handleOpenModal = (order) => {
        setShowModal(true);
        setReorderData(order)
    }

    const handleClose = async () => {
        setShowModal(false);
    };


    return (
        <>
            <ReorderModal
                show={showModal}
                onClose={handleClose}
                reorderData={reorderData}
            />

            <div
                className="tab-pane fade"
                id="favourite"
                role="tabpanel"
                aria-labelledby="favourite-tab"
            >
                <div className="tab_innerBody">
                    <div className="tab_innerBodyTitle">
                        <h4>Min Favorit</h4>
                    </div>
                    <div className="tab_subItems">
                        <div className="tab_tableItem">
                            <table className="table table-striped text-center" style={{ tableLayout: 'auto' }}>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th scope="col">Bestilling ID</th>
                                        <th scope="col">Barn</th>
                                        <th scope="col">Bestilling</th>
                                        <th scope="col">Image</th>
                                        <th scope="col">Pris</th>
                                        <th scope="col">Antal</th>
                                        <th scope="col">Total</th>
                                        <th scope="col">Re-order</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(favourites?.order) && favourites?.order?.length > 0 ? (
                                        favourites.order.map((order, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        <i
                                                            className={`fa-star fa ${order?.isFavorite ? 'fa-solid' : 'fa-regular'}`}
                                                            style={{
                                                                cursor: 'pointer',
                                                                color: order?.isFavorite ? '#999' : '#EE4D1A'
                                                            }}
                                                            onClick={() => toggleFavorite(order?.OrderId)}
                                                        ></i>
                                                    </td>
                                                    <td>{order.OrderId}</td>
                                                    <td>{order?.Order?.Child?.name || 'Child Name'}</td>
                                                    <td
                                                        dangerouslySetInnerHTML={{
                                                            __html: order?.OrdersItem?.itemName?.replace(/<[^>]+>/g, '') || 'Item Name'
                                                        }}
                                                    ></td>
                                                    <td>
                                                        <img
                                                            src={
                                                                order?.OrdersItem?.image
                                                                    ? `${image_url}${MENU_IMAGE_PATH}` +
                                                                    order?.OrdersItem?.image
                                                                    : ""
                                                            }
                                                            alt="not found"
                                                            style={{
                                                                height: '70px',
                                                                width: '70px',
                                                                borderRadius: '50%',
                                                                objectFit: 'cover',
                                                                border: '2px solid #ddd'
                                                            }}
                                                        />
                                                    </td>
                                                    <td>{order?.OrdersItem?.price || 'Price'} Kr</td>
                                                    <td>{order?.OrdersItem?.quantity || 'Quantity'}</td>
                                                    <td>{order?.Order?.totalPrice || 'Total Price'} Kr</td>
                                                    <td>
                                                        <i
                                                            className="fa fa-pen"
                                                            data-bs-toggle="tooltip"
                                                            title="Genbestil"
                                                            onClick={() => handleOpenModal(order)}
                                                            style={{ cursor: 'pointer' }}
                                                        ></i>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="9" className="text-center">
                                                Ingen favoritter fundet
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                {/* Pagination component */}
                <Pagination
                    totalPage={favourites?.pagination?.totalPages}
                    currentPage={favourites?.pagination?.currentPage}
                    fullPagination={paginationWithPage}
                />
            </div>
        </>
    )
}

export default UserFavourite